import React from "reactn";
import { NewTabbedTable } from "../../components/UI";
import { MiniPlus } from "../../assets";
import axios from "axios";
import { toast } from "react-toastify";
import { format } from "date-fns";
import AddIframeModal from "../../components/modals/AddIframeModal";
import LinkIcon from "@material-ui/icons/Link";
import { Delete, SettingsBackupRestore as Restore } from "@material-ui/icons";
import CreatePartyModal from "../../components/modals/CreatePartyModal";
import PreviewPartyListingsModal from "../../components/modals/PreviewPartyListingsModal";
import CopyExistingPartyModal from "../../components/modals/CopyExistingPartyModal";
import PartyAddonsModal from "../../components/modals/PartyAddonsModal";
import Switch from "@material-ui/core/Switch";
import ReactTooltip from "react-tooltip";
import ConfirmArchiveModal from "../../components/modals/ConfirmArchiveModal";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { DateTime } from "luxon";
import { utcToZonedTime } from "date-fns-tz";
import ViewArchivedPartyDetailsModal from "../../components/modals/ViewArchivedPartyDetailsModal";
import AIPartyInspirationModal from "../../components/modals/AIPartyInspirationModal";

const styles = {
  filter: {
    height: "165px",
    "& .MuiList-padding": {
      paddingTop: "0px !important",
      paddingBottom: "0px !important"
    }
  },
  filterArchived: {
    height: "130px",
    "& .MuiList-padding": {
      paddingTop: "0px !important",
      paddingBottom: "0px !important"
    }
  },
  checkbox: {
    minWidth: "32px",
    "& .MuiListItemIcon-root": {
      minWidth: "40px"
    }
  }
};
class PartiesList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      data: { Parties: [] },
      allData: [],
      partyCount: { Parties: [], Archive: [] },
      filter: "",
      tours: [],
      original: [],
      leadModal: false,
      partiesPermissions: {},
      openCreatePartyModal: false,
      openPreviewPartyListingsModal: false,
      openCopyExistingPartyModal: false,
      openPartyAddonsModal: false,
      showConfirmModal: false,
      showConfirmHideModal: false,
      toArchive: true,
      toHide: true,
      idToEdit: 0,
      cancelAllApplications: false,
      filterListChecked: [],
      isPreview: true,
      isName1: false,
      isDate1: false,
      isDate2: false,
      currTab: 0,
      previewOrder: [],
      previewUpdated: false,
      page: -1,
      openAIInspirationModal: false
    };

    this.tabs = ["Parties", "Archive"];

    this.actions = [{ name: "Notes", action: null }];
    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Parties", to: "/parties/list" }
      ]
    });

    this.handleFilterListToggle = this.handleFilterListToggle.bind(this);
    this.filterListLabels = [
      "Preview Order",
      "Name (A to Z)",
      "Created Date (new to old)",
      "Update Date (new to old)"
    ];
  }

  getTimeZone = () => {
    const tz = this.global.organizationInfo.timezone;

    return DateTime.now().setZone(tz).toFormat("ZZZZ");
  };

  headings = () => {
    return {
      Parties: [
        {
          id: "pic",
          label: "",
          customCell: (r, i) => (
            <td key={i} style={{ whiteSpace: "nowrap" }}>
              <LazyLoadImage
                src={`${
                  process.env.REACT_APP_DS_FILES_S3 + "/" + r.party_image
                }`}
                style={{
                  width: "130px",
                  height: "78px",
                  borderRadius: "7px",
                  objectFit: "cover"
                }}
                effect="opacity"
              />
            </td>
          )
        },
        { id: "party_title", label: "Party Title" },
        {
          id: "party_start",
          label: `Starts (${this.getTimeZone()})`,
          customCell: row => {
            const tz = this.global.organizationInfo.timezone;
            const startZonedTimeDisplay = format(
              utcToZonedTime(row.party_start, tz),
              "LLL dd, yyyy - h:mm a"
            );

            return <td key={`${row.id}-start`}>{startZonedTimeDisplay}</td>;
          }
        },
        {
          id: "party_end",
          label: `Ends (${this.getTimeZone()})`,
          customCell: row => {
            const tz = this.global.organizationInfo.timezone;
            const startZonedTimeDisplay = format(
              utcToZonedTime(row.party_end, tz),
              "LLL dd, yyyy - h:mm a"
            );

            return <td key={`${row.id}-start`}>{startZonedTimeDisplay}</td>;
          }
        },
        {
          id: "address1",
          label: "Location"
        },
        {
          id: "published",
          label: "Publish",
          customCell: (r, i) => {
            return (
              <td key={i}>
                <Switch
                  checked={r.published}
                  size="small"
                  onChange={_ => {
                    this.updatePublishStatus(r);
                  }}
                  disabled={
                    this.canSubUserEdit() ||
                    !r.party_title ||
                    !r.party_start ||
                    !r.party_end ||
                    !r.address1 ||
                    !r.description ||
                    !r.party_image ||
                    r.tickets.filter(plan => {
                      let ret = false;
                      const { active, archived } = JSON.parse(plan);
                      if ((active === undefined || active) && !archived)
                        ret = true;
                      return ret;
                    }).length === 0 ||
                    r.formId === null
                  }
                  color="primary"
                />
              </td>
            );
          }
        },
        {
          id: "actionf",
          label: "",
          customCell: (r, i) => {
            return (
              <td
                key={`${i}-btn`}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              >
                <div className="action-group">
                  <button
                    style={{
                      marginRight: "15px",
                      cursor: this.canSubUserEdit() ? "not-allowed" : "pointer"
                    }}
                    disabled={this.canSubUserEdit()}
                    onClick={() =>
                      this.props.history.push(`/partners/parties/setup/${r.id}`)
                    }
                  >
                    Edit
                  </button>
                  <LinkIcon
                    style={{
                      transform: "rotate(130deg)",
                      marginRight: "10px",
                      color: "darkgrey"
                    }}
                    onClick={_ =>
                      this.setState({
                        iframeSetUp: true,
                        selectedIframe: r.id,
                        type: "party"
                      })
                    }
                    className="hovermyX"
                  />
                  {!this.canSubUserEdit() && (
                    <>
                      <Delete
                        onClick={() => {
                          this.setState({
                            showConfirmModal: true,
                            idToEdit: r.id,
                            toArchive: true
                          });
                        }}
                        data-for="archive"
                        data-tip
                      />
                      <ReactTooltip
                        id="archive"
                        place="top"
                        effect="solid"
                        type="info"
                      >
                        Archive Party
                      </ReactTooltip>
                    </>
                  )}
                </div>
              </td>
            );
          }
        }
      ],
      Archive: [
        {
          id: "pic",
          label: "",
          customCell: (r, i) => (
            <td key={i} style={{ whiteSpace: "nowrap" }}>
              <LazyLoadImage
                src={`${
                  process.env.REACT_APP_DS_FILES_S3 + "/" + r.party_image
                }`}
                style={{
                  width: "130px",
                  height: "78px",
                  borderRadius: "7px",
                  objectFit: "cover"
                }}
                effect="opacity"
              />
            </td>
          )
        },
        { id: "party_title", label: "Party Title" },
        {
          id: "party_start",
          label: `Starts (${this.getTimeZone()})`,
          customCell: row => {
            const tz = this.global.organizationInfo.timezone;
            const startZonedTimeDisplay = format(
              utcToZonedTime(row.party_start, tz),
              "LLL dd, yyyy - h:mm a"
            );

            return <td key={`${row.id}-start`}>{startZonedTimeDisplay}</td>;
          }
        },
        {
          id: "party_end",
          label: `Ends (${this.getTimeZone()})`,
          customCell: row => {
            const tz = this.global.organizationInfo.timezone;
            const startZonedTimeDisplay = format(
              utcToZonedTime(row.party_end, tz),
              "LLL dd, yyyy - h:mm a"
            );

            return <td key={`${row.id}-start`}>{startZonedTimeDisplay}</td>;
          }
        },
        {
          id: "address1",
          label: "Location"
        },
        {
          id: "published",
          label: "Publish",
          customCell: (r, i) => (
            <td key={i}>{r.published ? "Published" : "Not Published"}</td>
          )
        },
        {
          id: "actionf",
          label: "",
          customCell: (r, i) => {
            return (
              <td
                key={`${i}-btn`}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              >
                <div className="action-group">
                  <button
                    style={{
                      marginRight: "15px",
                      cursor: "pointer"
                    }}
                    onClick={_ =>
                      this.setState({
                        openViewArchivedModal: true,
                        idToEdit: r.id
                      })
                    }
                  >
                    View
                  </button>

                  {!this.canSubUserEdit() &&
                    this.showCreateNewPartyButton() && (
                      <>
                        <Restore
                          style={{ color: "#BBB" }}
                          onClick={() => {
                            this.setState({
                              showConfirmModal: true,
                              idToEdit: r.id,
                              toArchive: false,
                              notAllowedToDelete: false
                            });
                          }}
                          data-for="restore"
                          data-tip
                        />
                        <ReactTooltip
                          id="restore"
                          place="top"
                          effect="solid"
                          type="info"
                        >
                          Restore Party
                        </ReactTooltip>
                      </>
                    )}
                  {!this.canSubUserEdit() &&
                    this.showCreateNewPartyButton() && (
                      <>
                        <Delete
                          style={{ color: "#BBB" }}
                          onClick={() => {
                            this.setState({
                              showConfirmHideModal: true,
                              idToEdit: r.id,
                              toArchive: true,
                              toHide: true,
                              cancelAllApplications:
                                !!this.state.customers.find(customer => {
                                  return (
                                    customer.partyId === r.id &&
                                    (customer.status_stage ===
                                      "Accepted_Unpaid" ||
                                      customer.status_stage === "New_Pending" ||
                                      customer.status_stage ===
                                        "Accepted_Manual" ||
                                      customer.status_stage ===
                                        "Waitlisted_Unpaid")
                                  );
                                })
                            });
                          }}
                          data-for="hide"
                          data-tip
                        />
                        <ReactTooltip
                          id="hide"
                          place="top"
                          effect="solid"
                          type="info"
                        >
                          Delete Party
                        </ReactTooltip>
                      </>
                    )}
                </div>
              </td>
            );
          }
        }
      ]
    };
  };

  updatePublishStatus = async r => {
    const ep = `${process.env.REACT_APP_API}/partners/parties/publish`;
    const results = await axios.post(ep, {
      id: r.id,
      published: !r.published
    });

    if (results.data.success) {
      this.fetchInitialData();
    }
  };

  /**
   * Makes request to backend to archive/unarchive party.
   * Uses state to determine options (what to delete, archive/unarchive).
   */
  archiveParty = async () => {
    const ep = `${process.env.REACT_APP_API}/partners/parties/cancel/${this.state.idToEdit}`;
    const result = await axios.post(ep);
    const ep2 = `${process.env.REACT_APP_API}/partners/parties/delete/${this.state.idToEdit}`;
    const results2 = await axios.post(ep2, { toArchive: this.state.toArchive });

    if (result.data.success && results2.data.success) {
      this.fetchInitialData();
    }
  };

  /**
   * Makes request to backend to hide an party from archive.
   * Looks like a permanent deletion, but is only hidden from the partner's view.
   * Party still stored in database
   */
  hideParty = async () => {
    const ep = `${process.env.REACT_APP_API}/partners/parties/hide/${this.state.idToEdit}`;
    const results = await axios.post(ep, { toHide: this.state.toHide });

    if (results.data.success) {
      this.fetchInitialData();
    }
  };

  cancelPartyApplications = async () => {
    let partyCustomerArr = [];

    this.state.customers.forEach(customer => {
      if (customer.partyId === this.state.idToEdit) {
        if (
          customer.status_stage === "Accepted_Unpaid" ||
          customer.status_stage === "New_Pending" ||
          customer.status_stage === "Waitlisted_Unpaid" ||
          customer.status_stage === "Accepted_Manual"
        ) {
          partyCustomerArr.push({
            id: customer.id,
            programId: customer.partyId
          });
        }
      }
    });

    console.log("EVENT CUSTOMERS", partyCustomerArr);

    const ep = `${process.env.REACT_APP_API}/partners/parties/cancel-application/${this.state.idToEdit}`;
    const results = await axios.post(ep, { partyCustomerArr });
  };

  async componentDidMount() {
    this.fetchInitialData();
  }

  /**
   * This function handles the edit button functionality of a sub user
   */
  canSubUserEdit = () => {
    return !(
      !this.global.dsUser.sub_user ||
      this.global?.dsUser?.accesspoints?.Listings?.Parties?.edit
    );
  };

  fetchInitialData = async () => {
    this.setGlobal({ loading: true });
    let tab = "active";
    if (this.state.currTab === 0) {
      tab = "active";
    } else if (this.state.currTab === 1) {
      tab = "archived";
    } else {
      console.log("NO TAB FOUND");
    }

    const ep = `${process.env.REACT_APP_API}/partners/parties/list/${tab}`;
    console.time("initial_results_fetch");
    const results = await axios.get(ep);
    console.timeEnd("initial_results_fetch");

    const party_count_ep = `${process.env.REACT_APP_API}/partners/parties/list/count`;
    console.time("initial_count_fetch");
    const party_count_results = await axios.get(party_count_ep);
    console.timeEnd("initial_count_fetch");

    const partyCount = {
      Parties: party_count_results.data.data.filter(
        e => !e.isArchived && !e.isHidden
      ),
      Archive: party_count_results.data.data.filter(
        e => e.isArchived && !e.isHidden
      )
    };
    console.log("EVENT COUNT", partyCount);

    // Get customers to check if parties have any enrollments.
    const customers_ep = `${process.env.REACT_APP_API}/partners/parties/customers/active/${this.global.organizationInfo.partnerId}`;
    console.time("initial_party_customers_fetch");
    const customers = await axios.get(customers_ep);
    console.timeEnd("initial_party_customers_fetch");

    const previewOrderEp = `${process.env.REACT_APP_API}/partners/parties/list/active`;
    const previewOrderResults = await axios.get(previewOrderEp);

    /*     if (results.data.success) {
      this.setState({
        data: {
          Parties: results.data.data
            .filter(f => !f.isArchived)
            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)),
          Archive: results.data.data
            .filter(f => f.isArchived)
            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        },
        customers: customers.data.data
      });  
    } */

    if (results.data.success) {
      this.setState({
        allData: results.data.data
          .filter(f => !f.isArchived)
          .map(e => ({ ...e, status: "Published", classification: "active" }))
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .concat(
            results.data.data
              .filter(f => f.isArchived)
              .map(e => ({ ...e, classification: "archive" }))
              .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          ),
        partyCount: partyCount,
        customers: customers.data.data,
        previewOrder: previewOrderResults.data.data
          .filter(f => !f.isArchived && !f.isHidden && f.published)
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .sort((a, b) => a.display_order - b.display_order)
      });
    }
    const permissions = await this.getPartiesPermissions();

    this.setState({ partiesPermissions: permissions });
    this.setGlobal({ loading: false });
  };

  showCreateNewPartyButton = () => {
    const { data, partiesPermissions } = this.state;
    if (data && partiesPermissions) {
      return (
        partiesPermissions.has_access &&
        partiesPermissions.has_feature_limit &&
        data.Parties.length < partiesPermissions.featureLimit
      );
    }
    return false;
  };
  getPartiesPermissions = async () => {
    const feature_name = "parties";
    const ep = new URL(
      `${process.env.REACT_APP_API}/partner/permissions/feature/${feature_name}`
    );
    const resp = await axios.get(ep);

    if (!(resp.data && resp.data.success)) {
      return false;
    } else {
      return resp.data.data;
    }
  };

  acceptPartnership = async row => {
    const ep = `${process.env.REACT_APP_API}/adm/partner/accept`;
    const results = await axios.post(ep, { partner: row });
    if (results.data.success) {
      toast.success(`Partner Accepted`);
      this.componentDidMount();
    } else {
      toast.error(`Error, this person already signed-up!`);
    }
  };
  daysInSystem = (r, i) => {
    return (
      <td key={i}>
        {parseInt(
          (Date.now() - new Date(r.createdAt).getTime()) / (3600000 * 24)
        )}
      </td>
    );
  };

  handleClose() {
    this.setState({
      popoverAnchorE1: null
    });
  }

  handleFilterClick(party) {
    this.setState({
      popoverAnchorE1: party.currentTarget
    });
  }

  handleFilterListToggle(value) {
    const currentIndex = this.state.filterListChecked.indexOf(value);
    const newChecked = [...this.state.filterListChecked];

    if (currentIndex === -1 && this.state.filterListChecked.length === 0) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
      newChecked.push(value);
    }

    const isPreview = value == "Preview Order";
    const isName1 = value == "Name (A to Z)";
    const isDate1 = value == "Created Date (new to old)";
    const isDate2 = value == "Update Date (new to old)";

    this.setState({
      filterListChecked: newChecked,
      isPreview: localStorage.setItem("isPreview", isPreview) || isPreview,
      isName1: localStorage.setItem("isName1", isName1) || isName1,
      isDate1: localStorage.setItem("isDate1", isDate1) || isDate1,
      isDate2: localStorage.setItem("isDate2", isDate2) || isDate2
    });
  }

  pipeData(allData) {
    if (allData.length > 0) {
      return {
        Parties: allData.filter(e => e.classification === "active"),
        Archive: allData.filter(
          e => e.classification === "archive" && !e.isHidden
        )
      };
    } else {
      return {
        Parties: [],
        Archive: []
      };
    }
  }

  filterData = () => {
    let data = this.state.allData;
    //const data = this.state.data.Active;
    console.log("data...", data);

    // Filter programs by filter bar
    if (this.state.filter && this.state.filter !== "") {
      data = data.filter(party => {
        const partyName = party.party_title.toLowerCase().replace(/\s/g, "");
        const filterText = this.state.filter.toLowerCase().replace(/\s/g, "");
        return partyName.includes(filterText);
      });
    }

    // Filter by Preview Order
    if (this.state.isPreview) {
      const currentOrder = data
        .filter(f => !f.isArchived && !f.isHidden && f.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        .sort((a, b) => a.display_order - b.display_order);
      const filteredData = data
        .filter(f => f.isArchived || f.isHidden || !f.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      data = [...currentOrder, ...filteredData];
    }

    // Filter by Created Date (New to Old)
    if (this.state.isDate1) {
      data.sort((a, b) => {
        if (new Date(b.createdAt) < new Date(a.createdAt)) {
          return -1;
        }
        if (new Date(b.createdAt) > new Date(a.createdAt)) {
          return 1;
        }
        return 0;
      });
    }
    // Filter by Updated Date (New to Old)
    if (
      this.state.isDate2 ||
      (this.state.isPreview && this.state.currTab === 1)
    ) {
      data.sort((a, b) => {
        if (new Date(b.updatedAt) < new Date(a.updatedAt)) {
          return -1;
        }
        if (new Date(b.updatedAt) > new Date(a.updatedAt)) {
          return 1;
        }
        return 0;
      });
    }
    // Filter by Program Name (A to Z)
    if (this.state.isName1) {
      data.sort((a, b) =>
        a.party_title > b.party_title
          ? 1
          : b.party_title > a.party_title
          ? -1
          : 0
      );
    }

    return {
      ...this.pipeData(data)
    };
  };

  filterDataCount() {
    let dataCount = { ...this.state.partyCount };
    if (this.state.filter && this.state.filter !== "") {
      dataCount["Parties"] = dataCount["Parties"].filter(party => {
        const partyName = party.party_title.toLowerCase().replace(/\s/g, "");
        const filterText = this.state.filter.toLowerCase().replace(/\s/g, "");
        return partyName.includes(filterText);
      });
      dataCount["Archive"] = dataCount["Archive"].filter(party => {
        const partyName = party.party_title.toLowerCase().replace(/\s/g, "");
        const filterText = this.state.filter.toLowerCase().replace(/\s/g, "");
        return partyName.includes(filterText);
      });
    }

    return dataCount;
  }

  async getCurrTabData() {
    this.setGlobal({ loading: true });

    let tab = "active";
    if (this.state.currTab === 0) {
      tab = "active";
    } else if (this.state.currTab === 1) {
      tab = "archived";
    } else {
      console.log("NO TAB FOUND");
    }

    const ep = `${process.env.REACT_APP_API}/partners/parties/list/${tab}`;
    console.time("results_fetch");
    const results = await axios.get(ep);
    console.timeEnd("results_fetch");

    // Get customers to check if parties have any enrollments.
    const customers_ep = `${process.env.REACT_APP_API}/partners/parties/customers/active/${this.global.organizationInfo.partnerId}`;
    console.time("party_customers_fetch");
    const customers = await axios.get(customers_ep);
    console.timeEnd("party_customers_fetch");

    if (results.data.success) {
      this.setState({
        allData: results.data.data
          .filter(f => !f.isArchived)
          .map(e => ({ ...e, status: "Published", classification: "active" }))
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .concat(
            results.data.data
              .filter(f => f.isArchived)
              .map(e => ({ ...e, classification: "archive" }))
              .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          ),

        customers: customers.data.data
      });
    }

    this.setGlobal({ loading: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState && prevState.currTab !== this.state.currTab) {
      this.getCurrTabData();
      if (this.state.currTab === 0) {
        this.setState({
          isPreview: true,
          isDate1: false,
          isDate2: false,
          isName1: false
        });
        this.filterListLabels = [
          "Preview Order",
          "Name (A to Z)",
          "Created Date (new to old)",
          "Update Date (new to old)"
        ];
      } else {
        this.setState({
          isPreview: false,
          isDate1: false,
          isDate2: true,
          isName1: false
        });
        this.filterListLabels = [
          "Name (A to Z)",
          "Created Date (new to old)",
          "Update Date (new to old)"
        ];
      }
    }
  }

  togglePreviewUpdated() {
    this.setState({
      previewUpdated: false,
      currTab: 0,
      isPreview: true,
      isDate1: false,
      isDate2: false,
      isName1: false
    });
  }

  render() {
    return (
      <div className="admin">
        {this.state.openPreviewPartyListingsModal && (
          <PreviewPartyListingsModal
            onClose={() =>
              this.setState({ openPreviewPartyListingsModal: false })
            }
            onOrderSave={newOrder => {
              this.setState({ previewOrder: newOrder, previewUpdated: true });
              this.fetchInitialData();
            }}
            history={this.props.history}
            parties={this.state.previewOrder}
          />
        )}
        {this.state.openCopyExistingPartyModal && (
          <CopyExistingPartyModal
            onClose={() => {
              this.setState({ openCopyExistingPartyModal: false });
              this.fetchInitialData();
            }}
          />
        )}
        {this.state.openPartyAddonsModal && (
          <PartyAddonsModal
            onClose={() => this.setState({ openPartyAddonsModal: false })}
            history={this.props.history}
          />
        )}
        {this.state.iframeSetUp && (
          <AddIframeModal
            iframe={this.state.selectedIframe}
            open={this.state.iframeSetUp}
            type={this.state.type}
            active={this.state.active}
            onClose={() =>
              this.setState({
                iframeSetUp: false,
                selectedIframe: null,
                type: null,
                active: null
              })
            }
          />
        )}
        {this.state.openCreatePartyModal && (
          <CreatePartyModal
            dispatch={this.dispatch}
            onClose={_ => this.setState({ openCreatePartyModal: false })}
            history={this.props.history}
          />
        )}
        {this.state.openAIInspirationModal && (
          <AIPartyInspirationModal
            onClose={_ => this.setState({ openAIInspirationModal: false })}
            history={this.props.history}
          />
        )}
        {this.state.showConfirmModal && (
          <ConfirmArchiveModal
            onSubmit={() => {
              this.archiveParty();
            }}
            onClose={_ => this.setState({ showConfirmModal: false })}
            toArchive={this.state.toArchive}
            modalBody={
              this.state.toArchive
                ? "UPDATE: This functionality has been updated. " +
                  "It will automatically deactivate all enrollments, and archive the party. " +
                  "All the program data will still be saved. " +
                  "Please ensure you want to archive this party. "
                : ""
            }
            buttonName={this.state.toArchive ? "Archive" : undefined}
            notAllowed={false}
          />
        )}
        {this.state.showConfirmHideModal && (
          <ConfirmArchiveModal
            onSubmit={() => {
              if (this.state.cancelAllApplications) {
                // Cancel all applications and then hide the party
                this.cancelPartyApplications()
                  .then(() => this.hideParty())
                  .catch(error => console.log(error));
              } else {
                // Simply hide the party
                this.hideParty();
              }
            }}
            onClose={_ => this.setState({ showConfirmHideModal: false })}
            toArchive={this.state.toArchive}
            isPermanent={this.state.toHide}
            notAllowed={false}
            cancelApps={this.state.cancelAllApplications}
          />
        )}

        {this.state.openViewArchivedModal && (
          <ViewArchivedPartyDetailsModal
            program={
              this.filterData()["Archive"].filter(
                data => data.id === this.state.idToEdit
              )[0]
            }
            onClose={_ => this.setState({ openViewArchivedModal: false })}
          />
        )}

        <div className="container-fluid adminprofiles">
          <div className="row cont">
            <div
              className="col-md-6"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div style={{ display: "block" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "-30px"
                  }}
                >
                  <h1 style={{ marginRight: "30px" }}>Parties </h1>
                  <LinkIcon
                    style={{
                      transform: "scale(1.5) rotate(130deg)",
                      cursor: "pointer",
                      marginRight: "10px",
                      marginTop: "0.2px",
                      color: "black"
                    }}
                    onClick={_ =>
                      this.setState({
                        iframeSetUp: true,
                        active: "Parties"
                      })
                    }
                    className="hovermyX"
                  />
                </div>
                <div
                  style={{ marginLeft: "-6px", marginTop: "4px" }}
                  className="switch-tooltip-group"
                >
                  <Switch
                    checked={
                      !!this.global.organizationInfo.display_party_listings
                    }
                    size="small"
                    onChange={_ => {
                      this.setGlobal({
                        organizationInfo: {
                          ...this.global.organizationInfo,
                          display_party_listings:
                            !this.global.organizationInfo.display_party_listings
                        }
                      });
                      this.dispatch.saveOrganizationalProfile();
                    }}
                    color="primary"
                    disabled={this.canSubUserEdit()}
                  />
                  <i
                    data-tip
                    data-for="view-party-toggle"
                    className="fas fa-info-circle"
                    style={{ color: "#DCDCDC" }}
                  ></i>
                  <ReactTooltip
                    id="view-party-toggle"
                    place="right"
                    effect="solid"
                    type="info"
                  >
                    Toggles party tab visibility for users
                  </ReactTooltip>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="forbtnwrap justify-end">
                <div className="forbtnapp" style={{ marginLeft: "20px" }}>
                  <button
                    className="newapplications"
                    disabled={this.canSubUserEdit()}
                    style={{
                      cursor: this.canSubUserEdit() ? "not-allowed" : "pointer",
                      paddingLeft: "20px",
                      transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                      transformOrigin: "center"
                    }}
                    onClick={_ => {
                      this.setState({
                        openCopyExistingPartyModal: true
                      });
                    }}
                  >
                    Copy Existing
                  </button>
                </div>
                <div className="forbtnapp" style={{ marginLeft: "20px" }}>
                  {this.showCreateNewPartyButton() && (
                    <button
                      className="newapplications"
                      disabled={this.canSubUserEdit()}
                      style={{
                        cursor: this.canSubUserEdit()
                          ? "not-allowed"
                          : "pointer",
                        paddingLeft: "20px",
                        transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                        transformOrigin: "center"
                      }}
                      onClick={() =>
                        this.setState({ openPartyAddonsModal: true })
                      }
                    >
                      Add-ons
                    </button>
                  )}
                </div>
                <div className="forbtnapp" style={{ marginLeft: "20px" }}>
                  {this.showCreateNewPartyButton() && (
                    <button
                      className="newapplications"
                      disabled={this.canSubUserEdit()}
                      style={{
                        cursor: this.canSubUserEdit()
                          ? "not-allowed"
                          : "pointer",
                        paddingLeft: "20px",
                        transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                        transformOrigin: "center"
                      }}
                      onClick={() =>
                        this.setState({ openPreviewPartyListingsModal: true })
                      }
                    >
                      Order
                    </button>
                  )}
                </div>
                <div className="forbtnapp" style={{ marginLeft: "20px" }}>
                  {this.showCreateNewPartyButton() && (
                    <button
                      className="newapplications"
                      disabled={this.canSubUserEdit()}
                      style={{
                        cursor: this.canSubUserEdit()
                          ? "not-allowed"
                          : "pointer",
                          transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                          transformOrigin: "center"
                      }}
                      onClick={
                        _ => this.setState({ openCreatePartyModal: true })
                        // this.props.history.push("/partners/parties/setup")
                      }
                    >
                      <img
                        src={MiniPlus}
                        alt=""
                        style={{ alignSelf: "center" }}
                      />
                      Create New
                    </button>
                  )}
                </div>
                <div className="forbtnapp" style={{ marginLeft: "20px" }}>
                  {this.showCreateNewPartyButton() && (
                    <button
                      className="newapplications"
                      disabled={this.canSubUserEdit()}
                      style={{
                        cursor: this.canSubUserEdit()
                          ? "not-allowed"
                          : "pointer",
                        transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                        transformOrigin: "center"
                      }}
                      onClick={_ => {
                        this.setState({ openAIInspirationModal: true });
                      }}
                    >
                      <img
                        src={MiniPlus}
                        alt=""
                        style={{ alignSelf: "center" }}
                      />
                      AI Inspiration
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/*  ======================== Start of Filter Button ====================== */}
          <div className="row cont">
            <div className="col-md-12">
              <div className="forbtnwrap justify-end">
                <button
                  className="newapplications"
                  style={{
                    border: "1px solid #ccc",
                    padding: "4px 20px",
                    borderRadius: "4px",
                    display: "block",
                    background: "#ccc",
                    fontWeight: "700",
                    color: "white",
                    transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                    transformOrigin: "center"
                  }}
                  aria-describedby={
                    this.state.popoverAnchorE1
                      ? "simple-popover"
                      : undefined
                  }
                  onClick={this.handleFilterClick.bind(this)}
                >
                  Filter
                </button>
                <Popover
                  id={
                    this.state.popoverAnchorE1
                      ? "simple-popover"
                      : undefined
                  }
                  open={Boolean(this.state.popoverAnchorE1)}
                  anchorEl={this.state.popoverAnchorE1}
                  onClose={this.handleClose.bind(this)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                >
                  <List
                    className={
                      this.state.currTab === 0
                        ? this.props.classes.filter
                        : this.props.classes.filterArchived
                    }
                    disablePadding={false}
                  >
                    {this.filterListLabels.map((value, i) => {
                      const labelId = `checkbox-list-label-${i}`;
                      return (
                        <ListItem
                          key={value}
                          role={undefined}
                          dense
                          button
                          onClick={_ => {
                            this.handleFilterListToggle(value);
                          }}
                        >
                          <ListItemIcon
                            classes={{ root: this.props.classes.checkbox }}
                          >
                            <Checkbox
                              name={value}
                              edge="start"
                              checked={
                                value === "Preview Order"
                                  ? this.state.isPreview
                                  : value === "Name (A to Z)"
                                  ? this.state.isName1
                                  : value === "Created Date (new to old)"
                                  ? this.state.isDate1
                                  : value === "Update Date (new to old)"
                                  ? this.state.isDate2
                                  : false
                              }
                              disabled={
                                !this.filterListLabels.filter(f => f == value)
                              }
                              tabIndex={-1}
                              disableRipple
                              primary
                              color="primary"
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <ListItemText id={labelId} primary={value} />
                        </ListItem>
                      );
                    })}
                  </List>
                </Popover>
              </div>
            </div>
          </div>
          {/*  ======================== End of Filter Button ====================== */}
          <div className="cont">
            <div className="tablecont">
              <div
                style={{
                  display: "inline-flex",
                  flex: "1 1",
                  border: "none",
                  borderRadius: "10px",
                  overflow: "hidden",
                  width: "100%"
                }}
              >
                <i
                  className="fas fa-search"
                  style={{
                    padding: "8px",
                    background: "white",
                    marginTop: "10px"
                  }}
                />
                <input
                  type="text"
                  placeholder="Filter by party name"
                  style={{
                    border: "none",
                    fontSize: "13px",
                    padding: "5px",
                    outline: 0,
                    background: "white",
                    flex: 1,
                    marginTop: "10px"
                  }}
                  onChange={e =>
                    this.setState({
                      filter: e.target.value,
                      page: 0
                    })
                  }
                />
              </div>
              <div className="table-responsive">
                <NewTabbedTable
                  tabs={this.tabs}
                  headings={this.headings()}
                  //data={this.state.data}
                  data={this.filterData()}
                  dataCount={this.filterDataCount()}
                  actions={this.actions}
                  page={"Listings>Parties"}
                  isFirstTab={this.state.previewUpdated}
                  resetPreview={() => this.togglePreviewUpdated()}
                  setCurrTab={tab => {
                    this.setState({ currTab: tab });
                  }}
                  currentPage={this.state.page}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(PartiesList);
